import { render, staticRenderFns } from "./ProductTab.vue?vue&type=template&id=e3bf8d70&"
import script from "./ProductTab.vue?vue&type=script&lang=js&"
export * from "./ProductTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports